export const webmasterConstants = {
  REGISTER_REQUEST: 'WEBMASTER_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'WEBMASTER_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'WEBMASTER_REGISTER_FAILURE',

  LOGIN_REQUEST: 'WEBMASTER_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'WEBMASTER_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'WEBMASTER_LOGIN_FAILURE',

  LOGOUT: 'WEBMASTER_LOGOUT',

  EDIT_PROFILE_SUCCESS: 'EDIT_PROFILE_SUCCESS',
  EDIT_PROFILE_FAILURE: 'EDIT_PROFILE_FAILURE',
};
